export default __webpack_public_path__ + "static/media/logoApp.ded2b20d.svg";